module.exports = __webpack_public_path__ + "static/media/partiallyComplete.1c823242.svg";